import gql from 'graphql-tag';
import { answerFieldsFragment } from './answerFieldsFragment';
import { sessionReportScoreFieldsFragment } from './sessionReportScoreFieldsFragment';

export const sessionReportQuestionStepFieldsFragment = gql`
  fragment AdminSessionReportQuestionStepFields on SessionReportQuestionStep {
    type
    question
    answer {
      ...AdminAnswerFields
    }
    correctAnswer {
      ...AdminAnswerFields
    }
    score {
      ...AdminSessionReportScoreFields
    }
    comment
  }

  ${answerFieldsFragment}
  ${sessionReportScoreFieldsFragment}
`;